import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';

export const StripeProvider = ({ children }: { children: React.ReactNode }) => {
    const [stripe, setStripe] = useState<Stripe | null>(null);

    useEffect(() => {
        const init = async () => {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/config/stripe`);
            const { publishableKey } = await res.json();
            const stripeInstance = await loadStripe(publishableKey);
            setStripe(stripeInstance);
        };
        init().then(() => {}).catch(() => {
            console.log('Stripe wasn\'t loaded');
        });
    }, []);

    if (!stripe) return null; // albo loader

    return (
        <Elements stripe={stripe}>
            {children}
        </Elements>
    );
};
